import React, { Fragment, memo } from 'react';

import { DocumentContentTitle } from '@confluence/document-title/entry-points/DocumentContentTitle.ts';
import { LoginIfAnonymous } from '@confluence/login-if-anonymous';
import { RestrictedPage } from '@confluence/no-permission/entry-points/RestrictedPage.ts';

import { ContentExpansionContainer } from './styles.tsx';

type UnauthorizedScreenProps = {
	contentId: string;
	accessType: string;
};

export const UnauthorizedScreen: React.MemoExoticComponent<
	(props: UnauthorizedScreenProps) => React.JSX.Element
> = memo(
	(props: UnauthorizedScreenProps): React.JSX.Element => (
		<Fragment>
			<LoginIfAnonymous />
			<ContentExpansionContainer>
				<DocumentContentTitle siteTitleOnly />
				<RestrictedPage {...props} />
			</ContentExpansionContainer>
		</Fragment>
	),
);
